// @flow
import React from 'react';
import ClosedCustomerQuestionsCard from './components/ClosedCustomerQuestionsCard';
import OpenCustomerQuestionsCard from './components/OpenCustomerQuestionsCard';
import RecentMessagesCard from './components/RecentMessagesCard';
import SummaryCard from './components/SummaryCard';
import useAppData from './hooks/useAppData';
import styled from 'styled-components';
import { WrappedSpinner } from '../../spinner';

type AIAssistantProps = {
  clientId: string;
};

const Container = styled.div`
  padding: 20px;
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  flex-wrap: wrap;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const AltContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  font-size: 24px;
`;

const AIAssistant = ({ clientId }: AIAssistantProps) => {
  const { appData, loading } = useAppData(clientId);
  if (loading) {
    return (
      <AltContainer>
        <WrappedSpinner />
      </AltContainer>
    );
  }

  if (!appData) {
    return <AltContainer>An error occurred</AltContainer>;
  }

  return (
    <Container>
      <Column>
        <OpenCustomerQuestionsCard appData={appData} />
        <ClosedCustomerQuestionsCard appData={appData} />
      </Column>
      <Column>
        <RecentMessagesCard appData={appData} />
      </Column>
      <Column>
        <SummaryCard appData={appData} />
      </Column>
    </Container>
  );
};

export default AIAssistant;
